module.exports = __webpack_public_path__ + "media/images/themes/mandy/12-766c8d3a881a80f049cedd8bd131bd2b.png";